import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SecurityService {
  private configSubject = new BehaviorSubject<any>(null);
  public config$ = this.configSubject.asObservable();

  constructor() {}

  updateConfig(config: any) {
    // Feature disabled
  }

  ngOnDestroy() {
    // Feature disabled
  }
}
